import { render, staticRenderFns } from "./addMyCourse.vue?vue&type=template&id=1a0837f4&scoped=true"
import script from "./addMyCourse.vue?vue&type=script&lang=js"
export * from "./addMyCourse.vue?vue&type=script&lang=js"
import style0 from "./addMyCourse.vue?vue&type=style&index=0&id=1a0837f4&prod&lang=less"
import style1 from "./addMyCourse.vue?vue&type=style&index=1&id=1a0837f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0837f4",
  null
  
)

export default component.exports